import styled from '@emotion/styled';
import { Button } from 'antd';

export const BackButton = styled(Button)`
  width: 10rem;
  height: 3.5rem;
  font-size: 2rem;
  margin-top: auto;
  align-self: center;

  @media (max-width: 480px) {
    width: 8rem;
    height: 3rem;
    font-size: 1.5rem;
  }
`;
